<div class="wrapper">
    <div class="contentss">
        <img loading="lazy" src="assets/not-available.png" width="70%">
        <h3>Site under maintenance</h3>
    </div>
</div>